<template>
  <div class="container">
    <div class="content">
      <div id="canvasDom" class="voucher">
        <img src="static/img/voucher.png" @load="onLoadForBg"/>

        <div class="voucher-name">{{detail.memberName}}</div>
        <div class="voucher-title">{{detail.certTitle}}</div>
        <div class="voucher-content">
          {{detail.certInfo}}
        </div>
        <div class="voucher-write-down">
          <div>{{detail.certSign}}</div>
          <div>{{detail.createDate}}</div>
        </div>
      </div>
    </div>

    <div class="handle">
      <div class="handle-item" @click="download">
        <iain-image-domain w="40" h="40" src="static/img/mine/icon15.png" />
        <div class="handle-label">保存</div>
      </div>

      <div class="handle-item" @click="share">
        <iain-image-domain w="40" h="40" src="static/img/mine/icon16.png" />
        <div class="handle-label">分享</div>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'

export default {
  name: 'ActivityVoucher',
  data() {
    return {
      detail: {},

      bgLoad: false,

      Loading: null
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      const { id } = JSON.parse(this.$route.query.query)

      this.Loading = this.$toast.loading({ message: '获取凭证中...' })
      // const response = { success: true, code: 200, data: {} }
      const response = await this.$request.api.get({ url: this.$api.activityVoucherUrl + id })
      const { success, code, data, message } = response

      if (success && code === 200) {
        this.detail = data || {}
      } else {
        this.$toast.fail(message || '获取凭证失败')
      }

      this.Loading.message = '生成海报中...'
      this.$nextTick(this.generatePoster)
    },

    onLoadForBg() {
      this.bgLoad = true
      this.$nextTick(() => {
        setTimeout(this.generatePoster)
      })
    },

    async generatePoster() {
      if (!this.bgLoad) return
      const posterCanvas = await html2canvas(document.getElementById('canvasDom'), { backgroundColor: null, scale: 2 })
      this.codePoster = posterCanvas.toDataURL('image/png')
      this.Loading.clear()
    },

    download() {
      uni.postMessage({ data: { type: 'DOWNLOAD', base64: this.codePoster } })
    },

    share() {
      uni.postMessage({ data: { type: 'SHARE', base64: this.codePoster } })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: #f8f8f8;

  .content {
    padding: 50px 30px;

    .voucher {
      position: relative;

      img {
        width: 100%;
      }

      .voucher-name {
        position: absolute;
        top: 380px;
        left: 132px;
        width: 110px;
        font-size: 26px;
        text-align: center;
      }

      .voucher-title {
        position: absolute;
        top: 450px;
        left: 50%;
        font-size: 24px;
        transform: translate3d(-50%, 0, 0);
      }

      .voucher-content {
        position: absolute;
        top: 500px;
        left: 50%;
        width: 400px;
        height: 194px;
        font-size: 22px;
        line-height: 28px;
        text-indent: 2em;
        overflow: hidden;
        transform: translate3d(-50%, 0, 0);
      }

      .voucher-write-down {
        position: absolute;
        right: 135px;
        bottom: 170px;
        font-size: 22px;
        text-align: center;
      }
    }
  }

  .handle {
    display: flex;
    padding-bottom: 20px;

    .handle-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 50%;
      flex-shrink: 0;

      .handle-label {
        padding-top: 20px;
        color: #000000;
      }
    }
  }
}
</style>
